if (!customElements.get('mewo-mobile-drawer')) {
  customElements.define('mewo-mobile-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-menu-open]');
      this.breakpoint = matchMedia('(min-width: 921px)');
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.classList.add('mewo-navigation-open');
        this.trigger.setAttribute('aria-expanded', 'true');
      }, options);
      this.querySelector('[data-menu-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        document.documentElement.classList.remove('mewo-navigation-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.openSearchAfterClose) {
          this.openSearchAfterClose = false;
          this.closest('.mewo-header').querySelector('[data-search-open]')?.click();
        } else if (!this.breakpoint.matches) {
          this.trigger.focus({ preventScroll: true });
        }
      }, options);
      this.querySelector('[data-menu-search]')?.addEventListener('click', event => {
        if (!this.closest('.mewo-header').querySelector('[data-search-open]')) return;
        event.preventDefault();
        this.openSearchAfterClose = true;
        this.dialog.close();
      }, options);
      this.breakpoint.addEventListener('change', event => {
        if (event.matches && this.dialog.open) this.dialog.close();
      }, options);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      if (this.dialog?.open) {
        document.documentElement.style.overflow = this.previousOverflow || '';
        document.documentElement.classList.remove('mewo-navigation-open');
      }
    }
  });
}
